import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import VueViewer from 'v-viewer';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';
import JSEncrypt from 'jsencrypt';
import { SHA256 } from 'crypto-js';
import Cookies from 'js-cookie';
import 'viewerjs/dist/viewer.css';
import 'swiper/swiper-bundle.css';
import 'moment/locale/pt-br'; 
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import { loading } from './loading';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import TheMask from 'vue-the-mask';
import CKEditor from '@ckeditor/ckeditor5-vue';

SwiperCore.use([Navigation, Pagination]);

const app = createApp(App)

app.use(router)
app.use(vuetify)
app.use(VueViewer)
app.use(TheMask)
app.use(CKEditor)

app.config.globalProperties.$ckconfig = {
  toolbar: ['selectAll','heading', '|', 'bold', 'italic','strikethrough', 'underline','|', 'fontSize','fontFamily', 'link','|', 'fontColor', 'fontBackgroundColor', 'bulletedList', 'numberedList', 'blockQuote','alignment', 'insertTable', '|'],
  heading: {
    options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
    ]
},
fontFamily: {
  options: [
      'default',
      'Arial, Helvetica, sans-serif',
      'Courier New, Courier, monospace',
      'Georgia, serif',
      'Lucida Sans Unicode, Lucida Grande, sans-serif',
      'Tahoma, Geneva, sans-serif',
      'Times New Roman, Times, serif',
      'Trebuchet MS, Helvetica, sans-serif',
      'Verdana, Geneva, sans-serif'
  ],
  supportAllValues: true
},
fontSize: {
  options: [ 10, 12, 14, 'default', 18, 20, 22,25,30,50,60 ],
  supportAllValues: true
},
}

app.component('EasyDataTable', Vue3EasyDataTable);

app.config.globalProperties.$loading = loading; 
app.config.globalProperties.$DadosCompraManual = "FiancaquiPedidoManual"

app.config.globalProperties.$scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};


app.config.globalProperties.$Cookies = Cookies;
app.config.globalProperties.$CookiesDefaults = {
  expires: 0.0832, // Expira em 2 a 5 horas 
  path: '/',
  domain: '',
  secure: false,
  sameSite: 'strict',
};

app.config.globalProperties.$moment = moment
app.config.globalProperties.$imgURL = 'https://fiancaqui.com.br/imagensProducao/'
axios.defaults.baseURL = 'https://controle.fiancaqui.com.br/api'
//app.config.globalProperties.$imgURL = 'https://domusfianca.com.br/imagensProducao/'
//axios.defaults.baseURL = 'https://controle.domusfianca.com.br/api'
//app.config.globalProperties.$imgURL = '/ImagensProducao/'
//axios.defaults.baseURL = 'http://localhost:5000/api'


// Obtém o dia do ano (1 a 366)
const dayOfYear = moment().dayOfYear();
// Obtém o ano com 4 dígitos
const year = moment().year();
// Concatena o texto com o dia do ano e o ano
const hashedCookieUsuario = SHA256(`CookieSistemaAvanceDigital${dayOfYear}${year}`).toString();

app.config.globalProperties.$CookieUsuario = hashedCookieUsuario;

app.config.globalProperties.$mensagemSucesso = function (mensagem) {
  Swal.fire(' ', mensagem, 'success')
}
app.config.globalProperties.$mensagemErro = function (mensagem) {
  Swal.fire(' ', mensagem, 'error')
}
app.config.globalProperties.$mensagemAviso = function (mensagem) {
  Swal.fire({
    position: 'top-end',
    icon: 'warning',
    title: mensagem,
    showConfirmButton: false,
    timer: 3000 // Tempo em milissegundos (3 segundos neste exemplo)
  })
}

app.config.globalProperties.$mensagemAvisoSucesso = function (mensagem) {
  Swal.fire({
    position: 'top-end',
    icon: 'success',
    title: mensagem,
    showConfirmButton: false,
    timer: 2000 // Tempo em milissegundos (3 segundos neste exemplo)
  })
}

app.config.globalProperties.$mensagemConfirma = function (mensagem) {
  return Swal.fire({
    icon: 'warning',
    title: mensagem,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true
  });
};

// Criptografe os dados desejados
app.config.globalProperties.$axios = axios
axios.defaults.headers.common['Authorization'] = process.env.VUE_APP_AUTHORIZATION;

axios.interceptors.request.use((config) => {
  // Configurações adicionais antes de fazer a chamada à API
  app.config.globalProperties.$loading.value = true; // Definir o estado do loader como true
  return config;
});

axios.interceptors.response.use(
  (response) => {
    // Tratamento de sucesso da resposta da API
    app.config.globalProperties.$loading.value = false;  // Definir o estado do loader como false
    return response;
  },
  error => {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // Tratamento de erro para status 401 (Acesso não autorizado)
      app.config.globalProperties.$mensagemErro("Acesso não autorizado.");
    } else if (error.code === "ERR_NETWORK") {
      // Tratamento de erro para erro de rede
      app.config.globalProperties.$mensagemErro("Sistema fora do ar." + error);
    } else if (error.response && error.response.data && error.response.data.message) {
      // Tratamento de erro para outras respostas com mensagem
      app.config.globalProperties.$mensagemErro(error.response.data.message);
    } else {
      // Tratamento de erro genérico
      app.config.globalProperties.$mensagemErro("Falha ao conectar, contate o administrador.");
    }
    app.config.globalProperties.$loading.value = false;
    return Promise.reject(error);
  }
);

app.mount('#app')






